// import wx from 'weixin-js-sdk'
// var wx = require('weixin-js-sdk');
import {
	Message
} from 'element-ui'
export function initWxConfig(vm) {
	var that = vm;
	// var token = vm.util.getCookie('hbzy-user-token')
	var url =
		"/qy-api/get-jsapi-ticket/get-sign-url.json?corpid=wxf4cdff3841975b54&secret=lbpn1WBI9Zx5giymjahwJWeBS4ET-EmPp4DwIUpnGOc&token=OAsystem&url=" +
		encodeURIComponent(window.location.href);

	that.$http({
			url: url
		}).then((response) => {
			if (response.status == 200) {
				var timestamp = response.data.timestamp //时间戳
				var nonceStr = response.data.nonceStr //随机字符串
				var signature = response.data.signature //签名
				var appId = "wxf4cdff3841975b54" //企业id
				// wx.config({
				// 	beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
				// 	debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				// 	appId: appId, // 必填，企业微信的corpID
				// 	timestamp: timestamp, // 必填，生成签名的时间戳
				// 	nonceStr: nonceStr, // 必填，生成签名的随机串
				// 	signature: signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
				// 	jsApiList: ['selectEnterpriseContact','previewFile','closeWindow'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
				// });
				// wx.ready(function() {
				// });
				// wx.error(function(res) {
				// 	// Message({
				// 	// 	message: 'initWxConfig:' + JSON.stringify(res),
				// 	// 	type: 'error',
				// 	// 	duration: 3*1000
				// 	// });
				// 	// that.$Message.error('initWxConfig:' + JSON.stringify(res));
				// 	console.log('closeWindow:' + JSON.stringify(res));
				// });
				
				window.wx.config({
					beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题  
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
					appId: appId, // 必填，企业微信的corpID。公司的唯一标识‘ww20745c5e79cfa434’
					timestamp: timestamp, // 必填，生成签名的时间戳
					nonceStr: nonceStr, // 必填，生成签名的随机串，这里用的是自定义方法
					signature: signature, // 必填，签名，见附录-JS-SDK使用权限签名算法 https://work.weixin.qq.com/api/doc/90000/90136/90506
					jsApiList: ["selectEnterpriseContact","closeWindow","previewFile"] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来。所有JS接口列表见附录2
				});
				// 步骤三：通过ready接口处理成功验证。没有需要立即调用的api，可以不写
				window.wx.ready(function() {});
				// 步骤四：通过error接口处理失败验证
				window.wx.error(function(err) {});
			} else {
				// Message({
				// 	message: response.data.status_msg,
				// 	type: 'error',
				// 	duration: 3*1000
				// });
				console.log(response.data.status_msg);
				// that.$Message.error(response.data.status_msg);
			}
		})
		.catch((error) => {
			Message({
				message: error,
				type: 'error',
				duration: 3 * 1000
			});
			console.log(error)
			// alert("log:"+error)
			// that.$Message.error(JSON.stringify(error));
		});
}
